import React, {Component} from 'react';
import { Input } from 'antd';

const { Search } = Input;
/**
 * creat by tianruojun
 * @description 一个普通的搜索框
 * @class Search
 * @extends {Component}
 */
export default class Search_rmt extends Component {
    static defaultProps = {
        onChange: ()=>{},
        onSearch: ()=>{},
        style: {}
    };
    render() {
        let {placeholder,onChange,value,onSearch,style} = this.props;
        return (
            <div className={"searchComponent"}>
                <Search
                    value={value}
                    allowClear={true}
                    placeholder={placeholder || ''}
                    onChange={e => onChange(e.target.value)}
                    onSearch={val => onSearch(val)}
                    style={{width: 200, ...style}}
                />
                <style>{`
                    .searchComponent .ant-input-affix-wrapper .ant-input{border: 1px solid #eef2fb !important; background-color: #f5f8fc !important;}
                `}</style>
            </div>
        )
    }
}